export default class HatchEntries {
  static async getHatchEntries(filters = {}) {
    const params = new URLSearchParams();
    if (filters.river) params.append('river', filters.river);
    if (filters.order) params.append('order', filters.order);
    if (filters.region) params.append('region', filters.region);
    if (filters.month) params.append('month', filters.month);
    if (filters.active) params.append('active', 'true');
    if (filters.date) params.append('date', filters.date);
    if (filters.search) params.append('search', filters.search);

    const query = params.toString();
    const url = `/hatch_entries${query ? '?' + query : ''}`;

    return new Promise((resolve, reject) => {
      return fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async createEntry(data) {
    return new Promise((resolve, reject) => {
      return fetch('/hatch_entries', {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async updateEntry(id, data) {
    return new Promise((resolve, reject) => {
      return fetch(`/hatch_entries/${id}`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async deleteEntry(id) {
    return new Promise((resolve, reject) => {
      return fetch(`/hatch_entries/${id}`, {
        method: "DELETE",
        headers: { Accept: "application/json" }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  static async refreshConditions() {
    return new Promise((resolve, reject) => {
      return fetch('/hatch_entries/refresh_conditions', {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }
}
